export default "__VITE_ASSET__CSrNKBzF__"